export const gitVersion = {
  "commit": "eba3e5f",
  "buildDate": "2026-11-02T15:01:22.591Z"
}